import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import {
  DashboardJobsStatus,
  DashboardJobsType,
  useGetDashboardJobInfo,
} from '~/domain/DashboardJobs';
import { getInitialTab } from '../utils';

interface IProps {
  type: DashboardJobsStatus;
  jobType?: DashboardJobsType;
}

export const TABS = {
  OPEN: 'open',
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
} as const;

export type TShiftListTab = (typeof TABS)[keyof typeof TABS];

export const useShiftList = ({ type, jobType }: IProps) => {
  const navigate = useNavigate();
  const { data: dashboardInfo } = useGetDashboardJobInfo(jobType ? { jobType } : undefined);
  const activeTab: TShiftListTab = getInitialTab(type);

  const onChangeTab = useCallback(
    (tab: TShiftListTab) => {
      navigate(`/dashboard/jobs/${tab}`, { replace: true });
    },
    [navigate],
  );

  return {
    activeTab,
    onChangeTab,
    dashboardInfo,
  };
};
